import React from "react";
import CustomModal from "../CustomModal/CustomModal";
import FillingModalBody from "./FillingModalBody";
import { SectionInterface } from "../../../store/types/store";
import { useStoreSystem } from "../../../store";

type EditSectionModalType = {
    editSection: SectionInterface
}
const FillingModal: React.FunctionComponent<EditSectionModalType> = ({ editSection }) => {
    const { sectionEditModal, setSectionEditModal } = useStoreSystem((state) => ({
        sectionEditModal: state.sectionEditModal,
        setSectionEditModal: state.setSectionEditModal
    }));

    const onClose = () => {
        setSectionEditModal({ isOpen: false, section: undefined });
    }

    return (
        <CustomModal
            isOpenModal={sectionEditModal.isOpen && sectionEditModal?.type === 'fill'}
            onCloseModalCallback={onClose}
            style={{ height: "80vh" }}
        >
            <FillingModalBody editSection={editSection} />
        </CustomModal>
    );
};

export default FillingModal;
